import { render } from "./registration-invite.vue?vue&type=template&id=1f756894&scoped=true"
import script from "./registration-invite.vue?vue&type=script&lang=js"
export * from "./registration-invite.vue?vue&type=script&lang=js"

import "./registration-invite.vue?vue&type=style&index=0&id=1f756894&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f756894"]])

export default __exports__